<template>
  <div>
    <mt-header title="忘记密码">
      <router-link to="/login" slot="left">返回</router-link>
    </mt-header>

    <div class="set-box">
      <div class="phone-wrap">
          <!-- <i class="iconfont icon-shouji2" style="font-size: 0.4rem"></i> -->
        <input placeholder="请输入手机号" v-model="phone" type="text" />
      </div>
      <div class="phone-wrap">
        <input
          placeholder="图形验证码(点击更换)"
          maxlength="6"
          v-model="vcCode"
          type="text"
        />
        <div @click="vccaptchaHandle" class="label-wrap">
          <img :src="'data:image/png;base64,' + vcImg" alt="" />
        </div>
      </div>
      <div class="phone-wrap">
        <input
          class="ipt"
          placeholder="请输入短信验证码"
          v-model="verifyCode"
          type="text"
        />
        <button
          style="border: none"
          :disabled="codeDisable"
          @click="sendCode"
          class="label-wrap-code btn-send"
          :class="codeDisable ? 'bg-gray' : ''"
        >
          {{ codeTxt }}
        </button>
      </div>
      <div class="phone-wrap">
          <!-- <i class="iconfont icon-mima" style="font-size: 0.4rem"></i> -->
        <input
          placeholder="请设置一个新密码"
          v-model="newPassword"
          type="password"
        />
      </div>

      <div @click="changePasswordHandle" class="btn">确认</div>
    </div>
  </div>
</template>
<script>
import { vccaptcha, vcsend, changePassword,changePasswordOnly } from "@/api/api.js";
import { isEmpty, cacheGet, cacheSet, urlSearchObj } from "@/utils/util.js";
import { Toast } from "mint-ui";
export default {
  data() {
    return {
      codeDisable: false,
      codeTxt: "验证码",

      phone: "",

      vcImg: "",
      vcCode: "",
      uniqid: "",
      verifyCode: "",
      newPassword: "",

      token: "",
      insId: urlSearchObj().id,
      organizationUserId: "",
    };
  },
  mounted() {
    this.vccaptchaHandle();
  },
  methods: {
    async changePasswordHandle() {
      if (this.checkChange()) {
        try {
          await changePasswordOnly({
            phone: this.phone,
            verifyCode: this.verifyCode,
            newPassword: this.newPassword,
          });
          Toast("密码修改成功")
          setTimeout(() => {
            this.$router.replace("/");
          }, 1500);
        } catch (error) {
          Toast("出错啦！")
        }
      }
    },
    checkChange() {
      if (isEmpty(this.phone)) {
        Toast("没有输入手机号");
        return false;
      }
      if (isEmpty(this.verifyCode)) {
        Toast("请输入短信验证码");
        return false;
      }
      if (isEmpty(this.newPassword)) {
        Toast("请输入新密码");
        return false;
      }
      return true;
    },

    async vccaptchaHandle() {
      const res = await vccaptcha();
      this.vcImg = res.image;
      this.uniqid = res.uniqid;
    },

    async sendCode() {
      if (this.checkSendCode()) {
        await vcsend({
          phone: this.phone,
          uniqid: this.uniqid,
          text: this.vcCode,
          type: 3,
        });
        Toast("验证码发送成功");
        this.timeCount();
      }
    },
    timeCount() {
      var time = 60;
      this.codeTxt = `${time} s后`;
      this.codeDisable = true;
      var timer = setInterval(() => {
        this.codeTxt = `${--time} s后`;
        if (time <= 0) {
          clearInterval(timer);
          this.codeTxt = "验证码";
          this.codeDisable = false;
        }
      }, 1000);
    },

    checkSendCode() {
      if (isEmpty(this.phone)) {
        Toast("没有输入手机号");
        return false;
      }
      if (!/^1\d{10}$/.test(this.phone)) {
        Toast("请输入正确的手机号");
        return false;
      }
      if (isEmpty(this.vcCode)) {
        Toast("请输入图形验证码");
        return false;
      }
      return true;
    },
  },
};
</script>
<style lang="less" scoped>
.phone-wrap {
  border: 1px solid #eee;
  margin-top: 20px;
  width: 100%;
  height: 100px;
  margin-bottom: 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding-left: 10px;
  position: relative;
}
.btn {
  margin-top: 200px;
  width: 100%;
  height: 80px;
  background: #006feb;
  border-radius: 10px;
  text-align: center;
  font-size: 0.35rem;
  color: #fff;
  line-height: 80px;
}
.set-box {
  padding: 50px;
}
.label-wrap {
  width: 100px;
  height: 60px;
  position: absolute;
  right: 10px;
  top: 60%;
  transform: translateY(-50%);
  img {
    cursor: pointer;
    width: 100%;
    height: 100%;
  }
}
.label-wrap-code {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 180px;
  white-space: nowrap;
  height: 60px;
  border-radius: 10px;
  background: orange;
  color: #fff;
}
.bg-gray {
    background: #ccc!important;
}
</style>
